// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  MessageToNodeValueEntry,
  MessageToNodeValueEntryT,
  verifyMessageToNodeValueEntry,
} from "./message-to-node-value-entry";
import {
  NodeValueToMessageEntry,
  NodeValueToMessageEntryT,
  verifyNodeValueToMessageEntry,
} from "./node-value-to-message-entry";

/**
 * Bidirectional OPC UA <-> LN2 message mappings.
 */
export class OpcUaMappings implements flatbuffers.IUnpackableObject<OpcUaMappingsT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OpcUaMappings {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOpcUaMappings(bb: flatbuffers.ByteBuffer, obj?: OpcUaMappings): OpcUaMappings {
    return (obj || new OpcUaMappings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsOpcUaMappings(
    bb: flatbuffers.ByteBuffer,
    obj?: OpcUaMappings,
  ): OpcUaMappings {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OpcUaMappings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  nodeToMsg(index: number, obj?: NodeValueToMessageEntry): NodeValueToMessageEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeValueToMessageEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  nodeToMsgLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  msgToNode(index: number, obj?: MessageToNodeValueEntry): MessageToNodeValueEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new MessageToNodeValueEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  msgToNodeLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startOpcUaMappings(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addNodeToMsg(builder: flatbuffers.Builder, nodeToMsgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeToMsgOffset, 0);
  }

  static createNodeToMsgVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNodeToMsgVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMsgToNode(builder: flatbuffers.Builder, msgToNodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, msgToNodeOffset, 0);
  }

  static createMsgToNodeVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMsgToNodeVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endOpcUaMappings(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_to_msg
    builder.requiredField(offset, 6); // msg_to_node
    return offset;
  }

  static createOpcUaMappings(
    builder: flatbuffers.Builder,
    nodeToMsgOffset: flatbuffers.Offset,
    msgToNodeOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    OpcUaMappings.startOpcUaMappings(builder);
    OpcUaMappings.addNodeToMsg(builder, nodeToMsgOffset);
    OpcUaMappings.addMsgToNode(builder, msgToNodeOffset);
    return OpcUaMappings.endOpcUaMappings(builder);
  }

  unpack(): OpcUaMappingsT {
    return new OpcUaMappingsT(
      this.bb!.createObjList<NodeValueToMessageEntry, NodeValueToMessageEntryT>(
        this.nodeToMsg.bind(this),
        this.nodeToMsgLength(),
      ),
      this.bb!.createObjList<MessageToNodeValueEntry, MessageToNodeValueEntryT>(
        this.msgToNode.bind(this),
        this.msgToNodeLength(),
      ),
    );
  }

  unpackTo(_o: OpcUaMappingsT): void {
    _o.nodeToMsg = this.bb!.createObjList<NodeValueToMessageEntry, NodeValueToMessageEntryT>(
      this.nodeToMsg.bind(this),
      this.nodeToMsgLength(),
    );
    _o.msgToNode = this.bb!.createObjList<MessageToNodeValueEntry, MessageToNodeValueEntryT>(
      this.msgToNode.bind(this),
      this.msgToNodeLength(),
    );
  }

  unpackFields(...fields: string[]): OpcUaMappingsT {
    const t = new OpcUaMappingsT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_to_msg")) {
      t.nodeToMsg = this.bb!.createObjList<NodeValueToMessageEntry, NodeValueToMessageEntryT>(
        this.nodeToMsg.bind(this),
        this.nodeToMsgLength(),
      );
    }
    if (fieldSet.has("msg_to_node")) {
      t.msgToNode = this.bb!.createObjList<MessageToNodeValueEntry, MessageToNodeValueEntryT>(
        this.msgToNode.bind(this),
        this.msgToNodeLength(),
      );
    }
    return t;
  }
}

export class OpcUaMappingsT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeToMsg: NodeValueToMessageEntryT[] = [],
    public msgToNode: MessageToNodeValueEntryT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeToMsg === null || this.nodeToMsg === undefined) {
      throw new Error('Required field "node_to_msg" is not set');
    }
    if (this.msgToNode === null || this.msgToNode === undefined) {
      throw new Error('Required field "msg_to_node" is not set');
    }
    const nodeToMsg = OpcUaMappings.createNodeToMsgVector(
      builder,
      builder.createObjectOffsetList(this.nodeToMsg),
    );
    const msgToNode = OpcUaMappings.createMsgToNodeVector(
      builder,
      builder.createObjectOffsetList(this.msgToNode),
    );

    return OpcUaMappings.createOpcUaMappings(builder, nodeToMsg, msgToNode);
  }

  clone(): OpcUaMappingsT {
    const obj = new OpcUaMappingsT();
    obj.nodeToMsg = this.nodeToMsg.map((e) => e.clone());
    obj.msgToNode = this.msgToNode.map((e) => e.clone());
    return obj;
  }

  equals(other: OpcUaMappingsT): boolean {
    if (this.nodeToMsg.length !== other.nodeToMsg.length) return false;
    for (let i = 0; i < this.nodeToMsg.length; i++) {
      const a = this.nodeToMsg[i];
      const b = other.nodeToMsg[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.msgToNode.length !== other.msgToNode.length) return false;
    for (let i = 0; i < this.msgToNode.length; i++) {
      const a = this.msgToNode[i];
      const b = other.msgToNode[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyOpcUaMappings(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNodeValueToMessageEntry);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_to_msg");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMessageToNodeValueEntry);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "msg_to_node");
  } finally {
    verifier.popDepth();
  }
}
